import React, { useState } from "react";

function TripleSwitchButton({ onChange }) {
  const [state, setState] = useState("neutral");
  const [firstState, setFirstState] = useState(false);

  const handleStateChange = (newState) => {
    setState(newState);
    setFirstState(true);
    onChange(newState); // Call the onChange prop with the new state
  };

  return (
    <div className="switch-container">
      <div className={`switch-button ${state} pin-top`}>
        {state === "neutral" && <div className="circles neutral"></div>}
        {state === "active" ? (
          <div className="circles active">✔</div>
        ) : (
          <div
            className="cercle-purple-text select-label font-16px"
            style={{ right: "5px" }}
            onClick={() => handleStateChange("active")}
          >
            {state === "neutral" && firstState ? "✖" : "✔"}
          </div>
        )}
        {state === "inactive" ? (
          <div className="circles inactive">✖</div>
        ) : (
          <div
            className="cercle-purple-text font-16px"
            onClick={() => handleStateChange("inactive")}
          >
            {state === "neutral" && firstState ? "✔" : "✖"}
          </div>
        )}
      </div>
    </div>
  );
}

export default TripleSwitchButton;